import React from 'react';
import { IMAGEMOTION_PACKAGES, WELCOME_CREDITS } from '@rehub/pricing';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 border-t border-slate-800 bg-black/40 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-3">
              <img src="/Logo.webp" alt="Imagemotion AI" className="h-6 w-auto object-contain object-left" />
            </div>
            <p className="text-xs text-slate-500 leading-relaxed">
              AI-powered cinematic video tours from property photos. Turn still images into stunning walkthrough videos.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-xs font-semibold text-blue-400 uppercase tracking-wider mb-3">Product</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>AI Video Generation</li>
              <li>Photo-to-Video</li>
              <li>Cinematic Tours</li>
              <li>Custom Music & Branding</li>
            </ul>
          </div>

          {/* Pricing */}
          <div>
            <h4 className="text-xs font-semibold text-blue-400 uppercase tracking-wider mb-3">Pricing</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 bg-green-400 rounded-full" />
                {WELCOME_CREDITS} welcome credits on signup
              </li>
              <li>From {IMAGEMOTION_PACKAGES.quick.credits} credits per video</li>
              <li>Sample video with welcome credits</li>
              <li>Subscription & one-time packs</li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold text-blue-400 uppercase tracking-wider mb-3">Company</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>
                <a href="https://hub.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">
                  ReHub Studio
                </a>
              </li>
              <li>
                <a href="https://hub.rehub.studio/#/contact" className="hover:text-blue-400 transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="https://rehub.studio/terms" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">
                  Terms
                </a>
              </li>
              <li>
                <a href="https://rehub.studio/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-slate-600">
            © {year} ReHub Studio. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-[11px] text-slate-600">
            <span>Part of the ReHub Suite</span>
            <span className="text-slate-700">·</span>
            <span>One account, all apps</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
